module.exports = __webpack_public_path__ + "pc/img/logo3.eda5e6d0.png";